export const getCategoryId = (state) => state.categories.categoryID;

export const getCategorysections =state => state.categories.categorysections;
